import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { Coupon } from 'src/app/models/product-list';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'coupon-card',
  templateUrl: './coupon-card.component.html',
  styleUrls: ['./coupon-card.component.scss'],
})
export class CouponCardComponent implements OnInit {

  locationId: any;
  storeId: any;
  storeName: any;

  @Input() couponItem: Coupon;
    constructor(private navControl: NavController, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.locationId = this.activatedRoute.snapshot.params.loc;
    this.storeId = this.activatedRoute.snapshot.params.storeId;
    this.storeName = this.activatedRoute.snapshot.params.storeName;
  }

  viewMoreProducts() {
    this.navControl.navigateForward(['shopping/retail/products/', this.storeName, this.storeId, { loc: this.locationId }]);
  }
  navigate(){
    this.navControl.navigateForward(['/terms-and-condition'])
  }

}
